import { render, staticRenderFns } from "./relationcustomerfiles.vue?vue&type=template&id=1b83b01b&scoped=true&"
import script from "./relationcustomerfiles.vue?vue&type=script&lang=js&"
export * from "./relationcustomerfiles.vue?vue&type=script&lang=js&"
import style0 from "./relationcustomerfiles.vue?vue&type=style&index=0&id=1b83b01b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b83b01b",
  null
  
)

export default component.exports